import FinancialsTemplateFieldsFragment from "components/financials/modern/graphql/fragments/FinancialsTemplateFieldsFragment";
import gql from "graphql-tag";

export const StarredTemplatesQuery = gql`
  query StarredTemplates($filters: FinancialsTemplatesQueryFilters, $limit: Int = 30, $cursor: Cursor = null) {
    selfie {
      _id
      starredTemplates(
        limit: $limit
        cursor: $cursor
        filters: $filters
        orderBy: { field: STARRED_AT, direction: DESCENDING }
      ) {
        edges {
          node {
            ...FinancialsTemplateFields
          }
          starredAt
        }
        totalCount
        pageInfo {
          cursor
          hasNextPage
        }
      }
    }
  }

  ${FinancialsTemplateFieldsFragment}
`;
